/**
 * Flatten LDS linkedFlights → timeline legs for organized-tour profile UI.
 * @param {unknown} linkedFlights
 * @returns {Array<Record<string, unknown> & { direction: string; segmentLabel: string }>}
 */
export function extractOrganizedTourFlightLegs(linkedFlights) {
  if (!linkedFlights || typeof linkedFlights !== "object") return [];
  const raw = /** @type {{ flight?: unknown }} */ (linkedFlights).flight;
  if (!raw) return [];
  const flights = Array.isArray(raw) ? raw : [raw];
  const legs = [];
  flights.forEach((flightRow, flightIndex) => {
    if (!flightRow || typeof flightRow !== "object") return;
    const direction = flightIndex === 0 ? "outbound" : "return";
    const segmentLabel =
      flightIndex === 0 ? "טיסת הלוך" : flightIndex === 1 ? "טיסת חזור" : `מקטע ${flightIndex + 1}`;
    const legNode = /** @type {{ leg?: unknown }} */ (flightRow).leg;
    if (Array.isArray(legNode)) {
      legNode.forEach((leg, legIndex) => {
        if (leg && typeof leg === "object") {
          legs.push({
            .../** @type {Record<string, unknown>} */ (leg),
            direction,
            segmentLabel: legNode.length > 1 ? `${segmentLabel} · קטע ${legIndex + 1}` : segmentLabel,
          });
        }
      });
    } else if (legNode && typeof legNode === "object") {
      legs.push({
        .../** @type {Record<string, unknown>} */ (legNode),
        direction,
        segmentLabel,
      });
    }
  });
  return legs;
}

export function formatOrganizedTourFlightDateTime(raw) {
  const s = String(raw ?? "").trim();
  if (!s) return { date: "—", time: "" };
  const [datePart, timePart] = s.split(/\s+/);
  return { date: datePart || "—", time: timePart || "" };
}

export function formatOrganizedTourFlightDuration(minutes) {
  const m = Number(minutes);
  if (!Number.isFinite(m) || m <= 0) return "—";
  const h = Math.floor(m / 60);
  const min = m % 60;
  return `${h}:${String(min).padStart(2, "0")} שע׳`;
}
